var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveFbicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 11338"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.3715 3.98802H14V1.12603C13.2115 1.04084 12.4193 0.998781 11.6266 1.00003C9.27045 1.00003 7.65929 2.49402 7.65929 5.23002V7.58802H5V10.792H7.65929V19H10.847V10.792H13.4976L13.8961 7.58802H10.847V5.54502C10.847 4.60002 11.0895 3.98802 12.3715 3.98802Z",
    fill: "#eb2426"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveFbicon);
export default __webpack_public_path__ + "static/media/activeFbicon.73203f92810f5576b765725f5b187505.svg";
export { ForwardRef as ReactComponent };